module.exports = __webpack_public_path__ + "abc36232d5d140b3d745b83c2bb222f4.svg";